exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.mFnAmVlWqX6rzxQBnziie div{border-color:#ff6562}._309fz1WaKdUH0CGotxz5Xv{font-size:.8rem;color:red;margin-top:-1rem;margin-bottom:1rem;text-align:end}\n", ""]);

// exports
exports.locals = {
	"errorBorder": "mFnAmVlWqX6rzxQBnziie",
	"inputErrorMessage": "_309fz1WaKdUH0CGotxz5Xv"
};